import React from 'react';
import { LoggedInViewerContext } from './LoggedInViewerContext';
import type { ViewerContext_UserFragment } from './ViewerContext.generated';

export function useLoggedInViewer(): ViewerContext_UserFragment {
    const context = React.useContext(LoggedInViewerContext);

    if (context === undefined) {
        throw new Error('useLoggedInViewer must be used within a LoggedInViewerProvider');
    }

    return context;
}
